<h2 mat-dialog-title>{{ 'menu_item' | translate }}</h2>
<div mat-dialog-content>
    <table appFieldContainer>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'name_en' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="data.menuItem.nameEn" cdkFocusInitial>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'name_es' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="data.menuItem.nameEs">
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <app-money-picker
                    [label]="'price' | translate"
                    [currencies]="data.currencies"
                    [value]="initialMoneyValue"
                    (onValueChange)="onPriceChange($event)">
                </app-money-picker>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'description_en' | translate }}</mat-label>
                    <textarea matInput type="text" [(ngModel)]="data.menuItem.descriptionEn"></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'description_es' | translate }}</mat-label>
                    <textarea matInput type="text" [(ngModel)]="data.menuItem.descriptionEs"></textarea>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-checkbox [(ngModel)]="data.menuItem.containsAlcohol">{{ 'contains_alcohol' | translate }}</mat-checkbox>
            </td>
        </tr>
        <tr>
            <td>
                <app-heading>{{ 'categories' | translate }}</app-heading>
            </td>
        </tr>
        <tr>
            <td>
                <app-multi-select
                    [searchElementLabel]="'search_category' | translate"
                    [selectedElements]="data.menuItem.categories"
                    [allElements]="data.allCategories"
                    [textProvider]="categoryTextProvider"
                    [comparator]="categoryComparator"
                    [elementCreationHelper]="categoryCreationHelper"
                    (onSelectedElementsChange)="onSelectedCategoriesChange($event)">
                </app-multi-select>
            </td>
        </tr>
    </table>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="!isValidMenuEntry()" [mat-dialog-close]="data">{{ 'ok' | translate }}</button>
    <button mat-button (click)="closeDialog()">{{ 'cancel' | translate }}</button>
</div>
